(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["nc-price-context"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nc-price-context')) {
    customElements.define('nc-price-context', class extends HTMLElement {
      selectionVersion = 0;

      connectedCallback() {
        this.productSection = this.closest('.shopify-section, dialog');
        this.productSection?.addEventListener('shopify:product:select', this.onProductSelect);
      }

      disconnectedCallback() {
        this.productSection?.removeEventListener('shopify:product:select', this.onProductSelect);
        this.selectionVersion += 1;
      }

      onProductSelect = (event) => {
        if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
        if (!event.promise) return;

        const selectionVersion = ++this.selectionVersion;
        event.promise.then(({ detail }) => {
          if (!this.isConnected || selectionVersion !== this.selectionVersion || !detail?.html) return;
          if (detail.newProduct) {
            this.dataset.productId = String(detail.newProduct.id);
          } else if (detail.productId && String(detail.productId) !== this.dataset.productId) {
            return;
          }

          const updatedContext = detail.html.getElementById(this.id);
          if (!updatedContext) return;
          this.innerHTML = updatedContext.innerHTML;
          this.hidden = updatedContext.hidden;
        }).catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[nc-price-context] Variant update failed', error);
        });
      };
    });
  }
  } catch(e) { console.error(e); }
})();

})();
